import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, ScrollSmoother } from "gsap/all";
import DefaultBlock from "/scripts/default/block";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollSmoother);

export default class ScrollSmoothEffects extends DefaultBlock {
	init() {
		const DOM = {
			block: this.block,
			wrapper: this.block.querySelector(".scroll-smooth-effects__wrapper"),
			pin: this.block.querySelector(".scroll-smooth-effects__container"),
		};
		this.DOM = DOM;
	}

	initEvents() {
		const mm = gsap.matchMedia();

		mm.add(
			{
				isDesktop: "(min-width: 1240px)",
				dontReduceMotion: "(prefers-reduced-motion: no-preference)",
			},
			(context) => {
				const { isDesktop, dontReduceMotion } = context.conditions;

				if (!isDesktop || !dontReduceMotion) return;

				for (let i = 0; i < 40; i++) {
					const circle = document.createElement("div");
					const circleInner = document.createElement("div");
					const size = gsap.utils.random(0.1, 2);
					const scale = gsap.utils.mapRange(0.1, 2, 1, 9, size);
					const opacity = gsap.utils.mapRange(0.1, 2, 0.1, 0.9, size);
					const maxX = this.DOM.pin.clientWidth - size;
					const maxY = this.DOM.pin.clientHeight * 2;
					const top =
						(gsap.utils.random(0, maxY) / this.DOM.pin.clientHeight) * 100;
					const left =
						(gsap.utils.random(0, maxX) / this.DOM.pin.clientWidth) * 100;

					circle.classList.add("scroll-smooth-effects__circle");
					circle.dataset.scale = scale;
					circleInner.classList.add("scroll-smooth-effects__circle-inner");
					circle.style.top = `${top}vh`;
					circle.style.left = `${left}vw`;
					circleInner.style.width = `${size}vw`;
					circleInner.style.height = `${size}vw`;
					circleInner.style.opacity = opacity;

					circle.appendChild(circleInner);
					this.DOM.pin.appendChild(circle);
				}

				const circles = this.DOM.pin.querySelectorAll(
					".scroll-smooth-effects__circle"
				);

				const circlesTl = gsap
					.timeline({
						scrollTrigger: {
							trigger: this.DOM.wrapper,
							start: "top 90%",
							end: "bottom bottom",
							scrub: 1,
						},
					})
					.to(circles, {
						y: -window.innerHeight,
						"--fy": (index, target) => target.dataset.scale,
						stagger: 0.008,
						ease: "power2.inOut",
						duration: 1,
					})
					.to(
						circles,
						{
							opacity: 0,
							stagger: 0.008,
							ease: "power2.inOut",
							duration: 0.5,
						},
						"0.5"
					);

				const parallaxTl = gsap.timeline({
					scrollTrigger: {
						trigger: this.DOM.block,
						start: "top top",
						end: "bottom bottom",
						pin: this.DOM.pin,
						pinSpacing: false,
						scrub: 1,
					},
				});
			}
		);
	}
}
